import { render, staticRenderFns } from "./invigilatorForm.vue?vue&type=template&id=55216193&scoped=true&"
import script from "./invigilatorForm.vue?vue&type=script&lang=js&"
export * from "./invigilatorForm.vue?vue&type=script&lang=js&"
import style0 from "./invigilatorForm.vue?vue&type=style&index=0&id=55216193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55216193",
  null
  
)

export default component.exports